// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-6AQH_";
var _4 = "form__row-1HLGs";
var _5 = "title-3OrVB";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "form__row", _5 as "title" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "form__row": _4, "title": _5 }
